import { render, staticRenderFns } from "./receptionCreate.vue?vue&type=template&id=318e4246&"
import script from "./receptionCreate.vue?vue&type=script&lang=js&"
export * from "./receptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports